import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { NudosButton } from '../../../../../../../../components/NudosComponents';
import { IProductInfo, IToolData } from '../../../../../../../../types/products';
import {
  IreplaceLsTools,
  IlogisticServiceDetailsOrganizationData,
  IproductLocationData
} from '../../../../../../../../types/services';
import ReplacementToolsDropdown from '../ReplacementToolsDropdown/ReplacementToolsDropdown';
import { filterPillsToShow } from '../../../../../../../../utils/pillsFormat';
import {
  displayErrorNotification,
  displaySuccessNotification
} from '../../../../../../../../utils/displayNudosStandardNotifications';
import { replaceLsTools } from '../../../../../../../../services/services';
import { PRODUCT_CATEGORY } from '../../../../../../../../types/category';

const ChangeToolsModalCustomComponent = ({
  updateDataCallback,
  productInfo,
  organizationInfo,
  originalLocation
}: ChangeToolsModalCustomComponentProps) => {
  const { logisticServiceId } = useParams<{ logisticServiceId: string }>();
  const [currentTool, setCurrentTool] = useState<IToolData>();
  const [isLoading, setIsLoading] = useState(false);

  const pillsToShow = filterPillsToShow(productInfo?.pills || {});

  const replacementToolsSearchOptions = {
    place: originalLocation?.place || undefined,
    category: productInfo?.category || undefined,
    countryCode: originalLocation?.country?.code || undefined,
    organizationId: organizationInfo?.organizationId || undefined,
    userId: originalLocation?.userId || undefined
  };

  const getCategoryText = () => {
    switch (productInfo?.category) {
      case PRODUCT_CATEGORY.LAPTOP:
      case PRODUCT_CATEGORY.DEP_LAPTOPS:
      case PRODUCT_CATEGORY.CTO_LAPTOPS:
        return 'una laptop';
      case PRODUCT_CATEGORY.CELLPHONES:
        return 'un celular';
      case PRODUCT_CATEGORY.MONITORS:
        return 'un monitor';
      case PRODUCT_CATEGORY.FURNITURE:
      case PRODUCT_CATEGORY.CHAIRS:
      case PRODUCT_CATEGORY.DESKS:
        return 'un mobiliario';
      case PRODUCT_CATEGORY.PRINTERS:
        return 'una impresora';
      case PRODUCT_CATEGORY.ACCESSORIES:
        return 'un accesorio';
      case PRODUCT_CATEGORY.PC:
        return 'una PC';
      default:
        return 'una herramienta';
    }
  };

  const submit = async () => {
    if (!organizationInfo?.organizationId || !productInfo?.productId) return;
    if (!currentTool?.id || !logisticServiceId) return;
    try {
      setIsLoading(true);
      const body: IreplaceLsTools = {
        logisticServiceId: +logisticServiceId,
        organizationId: organizationInfo?.organizationId,
        productsToReplace: [{ originalProductId: productInfo?.productId, newProductId: +currentTool?.id }]
      };
      await replaceLsTools(body);
      await updateDataCallback();
      displaySuccessNotification({
        customJSXMessage: <>La herramienta se ha cambiado con éxito</>
      });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="changeToolsModal">
      <div className="subTitle">{`Elige ${getCategoryText()} del inventario en bodega para enviar en este onboarding`}</div>

      <div className="companyInfoContainer">
        <span>Empresa:</span>
        <span className="companyNameText">{organizationInfo?.organizationName}</span>
      </div>

      <div className="productInfoContainer">
        <span className="productItem">Herramienta actual:</span>
        <span className="productItem">{productInfo?.name?.trim()}</span>
        <span className="productItem">{`${pillsToShow.join(' / ')}`}</span>
        <span className="productItem"> - {productInfo?.serial || 'Sin serial'}</span>
      </div>

      <ReplacementToolsDropdown
        replacementToolsSearchOptions={replacementToolsSearchOptions}
        updateSelectedToolCallback={setCurrentTool}
        originalToolId={productInfo?.productId}
      />

      <NudosButton
        buttonText="Guardar cambios"
        customWidth="180px"
        customHeight="38px"
        handleClick={submit}
        isButtonDisabled={!currentTool}
        isButtonLoading={isLoading}
      />
    </div>
  );
};

export default ChangeToolsModalCustomComponent;

interface ChangeToolsModalCustomComponentProps {
  updateDataCallback: () => Promise<void>;
  productInfo: IProductInfo;
  organizationInfo: IlogisticServiceDetailsOrganizationData;
  originalLocation?: IproductLocationData | null;
}
